<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Customer Details</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Customer Details</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid">
          <div class="edit-profile">
           
            <div class="row">
              <div class="col-xl-12">
                <form class="card">
                  <div class="card-header pb-0">
                    <!-- <h4 class="card-title mb-0">Edit Profile</h4> -->
                    <div class="card-options">
                      <a class="card-options-collapse" href="#" data-bs-toggle="card-collapse"><i
                          class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="#"
                        data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">

                    <div class="col-8">
                          <div class="mb-8">
                        </div>
                    </div>

                      <div class="col-4">
                        <div class="mb-12">

                        
                        <div class="mb-3">

                            <router-link v-if="customer_id" :to="'/customer/edit/' + customer_id"
                              class="btn btn-primary btn-sm" type="button" data-original-title="btn btn-danger btn-xs"
                              title="" @click.prevent="updateType(customer_id)">
                              Update Customer info
                            </router-link>

                            </div>
                        
                      
                       
                        <div class="mb-3">
                             <router-link :to="'/customer-service/' + customer_id" class="btn btn-primary btn-sm"
                              type="button" data-original-title="btn btn-primary btn-xs" title=""
                              @click.prevent="updateType(customer_id)">
                               Update  Services Price
                            </router-link>
                          </div>
                       
                      
                       
                        <div class="mb-3">
                               <router-link :to="'/customer/service/list/' + customer_id"
                               class="btn btn-info btn-sm"
                              type="button" data-original-title="btn btn-primary btn-xs"
                               >Add / Remove Customer Wise Service
                                </router-link>
                        </div>
                         
            
                        </div>
                      </div>


                      

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Name</label>
                          <input class="form-control" v-model="this.data.name" type="text" placeholder=" Full Name"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Phone</label>
                          <input class="form-control" type="text" v-model="data.phone" placeholder=" Phone Number"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Email address</label>
                          <input class="form-control" v-model="data.email" type="email" placeholder=" Email"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Initial Date</label>
                          <input class="form-control" v-model="data.initial_date" type="date" placeholder=" Date"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">bin number</label>
                          <input class="form-control" v-model="data.bin_number" type="text" placeholder="bin number."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Company Name</label>
                          <input class="form-control" v-model="data.company_name" type="text" placeholder="Company Name"
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Flat</label>
                          <input class="form-control" v-model="data.flat_no" type="text" placeholder=" Flat No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">House</label>
                          <input class="form-control" v-model="data.house_no" type="text" placeholder=" House No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Road</label>
                          <input class="form-control" v-model="data.road_no" type="text" placeholder=" Road No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="mb-3">
                          <label class="form-label">Block</label>
                          <input class="form-control" v-model="data.block_no" type="text" placeholder=" Block No."
                            readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">District</label>
                          <select class="f1-email form-control" v-model="data.district"
                            v-if="this.districtList.length > 0" disabled>
                            <option value="" selected>Select District</option>
                            <option :key="district.id" v-for="district in districtList" :value="district.id" @change="
                              () => {
                                this.district = district.id;
                              }
                            ">
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Area One</label>
                          <select class="f1-email form-control" v-model="data.area_one"
                            v-if="this.areaList.length > 0" disabled>
                            <option value="" selected>Select Area One</option>
                            <option :key="district.id" v-for="district in areaList" :value="district.id" @change="
                              () => {
                                this.area_one = district.id;
                              }
                            ">
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Area Two</label>
                          <select class="f1-email form-control" v-model="data.area_two"
                            v-if="this.districtList.length > 0" disabled>
                            <option value="" selected>Select Area Two</option>
                            <option :key="district.id" v-for="district in districtList" :value="district.id" @change="
                              () => {
                                this.area_two = district.id;
                              }
                            ">
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div> -->
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">POP</label>
                          <select class="form-control" id="f1-first-name" type="text" v-model="data.pop_id"
                            placeholder=" POP" required="" disabled>
                            <option value="" disabled>Select POP</option>
                            <option v-for="p in popList" :key="p.id" :value="p.id">{{ p.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">remarks</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.remarks"
                            placeholder=" remarkss" required="" readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Bandwidth Type</label>
                          <select class="form-control" id="f1-first-name" type="text" v-model="data.bandwidth_type"
                            placeholder="Select Type" required="" disabled>
                            <option value="1">Dedicated</option>
                            <option value="2">Shared</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Bandwidth</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.bandwidth"
                            placeholder=" Bandwidth" required="" readonly />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Billing Date</label>
                          <input class="form-control" id="f1-first-name" type="number" v-model="data.billing_date"
                            placeholder=" date" required="" readonly />
                        </div>
                      </div>

                       <div class="col-sm-6 col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Connection Type *</label>
                          <select class="form-control" id="f1-first-name" type="text" v-model="data.customer_type"
                            placeholder=" POP" required="" disabled>
                            <option value="" disabled>Select Type</option>
                            <option v-for="p in connectionTypes" :key="p.id" :value="p.id">{{ p.title }}</option>
                            
                          </select>
                        </div>
                      </div>

                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">MRC</label>
                          <input class="form-control" id="f1-first-name" type="Number" v-model="data.mrc"
                            placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">OTC</label>
                          <input class="form-control" id="f1-first-name" type="Number" v-model="data.otc"
                            placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Total(including VAT)</label>
                          <input class="form-control" id="f1-first-name" type="Number"
                            v-model="data.total_price_with_vat" placeholder="0" required="" readonly />
                        </div>
                      </div> -->
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Opening Balance</label>
                          <input class="form-control" id="f1-first-name" type="Number" v-model="data.opening_balance"
                            placeholder="0" required="" readonly />
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Recurring Period</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.recuring_period"
                            placeholder=" Recurring Periods" required="" readonly />
                        </div>
                      </div> -->
                      <div class="col-lg-12"></div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Name</label>
                          <!-- //  v-model="data.contractAddressList[0].name" -->
                          <input class="form-control" id="f1-first-name" v-model="data.owner_name" type="text"
                            placeholder=" Owner Name" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Designation</label>
                          <input class="form-control" id="f1-first-name" v-model="data.owner_designation" type="text"
                            placeholder=" Owner Designation" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Phone</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.owner_phone_one"
                            placeholder=" Owner Phone" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Phone (secondary)</label>
                          <input class="form-control" id="f1-first-name" type="text" placeholder=" Owner Phone"
                            v-model="data.owner_phone_two" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Email</label>
                          <input class="form-control" id="f1-first-name" type="email" placeholder=" Owner Email"
                            v-model="data.owner_email" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4"></div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Name</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.technical_name"
                            placeholder=" Technical Name" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Designation</label>
                          <input class="form-control" id="f1-first-name" type="text"
                            v-model="data.technical_designation" placeholder=" Technical Designation" required=""
                            readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Phone</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.technical_phone_one"
                            placeholder=" Technical Phone" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Phone (secondary)</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.technical_phone_two"
                            placeholder=" Technical Phone" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Email</label>
                          <input class="form-control" id="f1-first-name" type="email" v-model="data.technical_email"
                            placeholder=" Technical Email" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4"></div>

                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Name</label>
                          <input class="form-control" id="f1-first-name" type="text" v-model="data.billing_contact_name"
                            placeholder=" Biller Name" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Designation</label>
                          <input class="form-control" id="f1-first-name" type="text"
                            v-model="data.billing_contact_designation" placeholder=" Designation" required=""
                            readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Phone</label>
                          <input class="form-control" id="f1-first-name" type="text"
                            v-model="data.billing_contact_phone_one" placeholder=" Phone Number" required=""
                            readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Secondary Phone</label>
                          <input class="form-control" id="f1-first-name" type="text"
                            v-model="data.billing_contact_phone_two" placeholder=" Secondary Phone Number"
                            required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-last-name">Biller Email</label>
                          <input class="f1-last-name form-control" id="f1-last-name" type="email"
                            v-model="data.billing_contact_email" placeholder=" Email" required="" readonly />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Billing Date</label>
                          <input class="form-control" id="f1-first-name" type="number" v-model="data.billing_date"
                            placeholder=" Billing Date" required="" readonly />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="card-footer text-end">
                    <button class="btn btn-primary" type="button" @click="updateCustomer">
                      Update Profile
                    </button>
                  </div> -->
                </form>
                <!-- Container-fluid Ends-->
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
// import CustomerAPI from "../../services/customer.API";
import areaRelatedAPI from "../../services/areaRelatedAPI";
import customerAPI from "../../services/customer.API";
import pop_typeAPI from '../../services/pop_type.API';
import connectionTypeAPI from '../../services/connectionType.API';
import moment from "moment";

export default {
  name: "CustomerEdit",
  data() {
    return {
      data: {
        active: 1,
        customer_type: "",
        name: "",
        email: "",
        phone: "",
        companyName: "",
        companyPhone: "",
        product_details: "",
        initial_date: "",
        bin_number: "",
        company_name: "",
        flat_no: "",
        house_no: "",
        road_no: "",
        block_no: "",
        district: "",
        area_one: "",
        area_two: "",
        pop_id: "",
        remarks: "",
        bandwidth_type: "",
        bandwidth: "",
        billing_date: "",
        mrc: "",
        otc: "",
        total_price_with_vat: "",
        opening_balance: "",
        recuring_period: "",
        owner_designation: "owner designation",
        owner_email: "",
        owner_name: "",
        owner_phone_one: "",
        owner_phone_two: "",
        technical_name: "",
        technical_designation: "",
        technical_phone_one: "",
        technical_phone_two: "",
        technical_email: "",
        billing_contact_name: "",
        billing_contact_designation: "",
        billing_contact_phone_one: "",
        billing_contact_phone_two: "",
        billing_contact_email: "",
        contractAddressList: [
          {
            name: "",
            designation: "",
            phone_one: "",
            phone_two: "",
            email: "",
          },
        ],
      },
      districtList: [],
      customer_id: "",
      popList: [],
      areaList: [],
      connectionTypes: [],
      connectionType: ''
    };
  },
  mounted() {
    // area list
    areaRelatedAPI.getList().then((response) => {
      this.areaList = response.data.data;
    });
     // list
     connectionTypeAPI.typeList().then((response) => {
      this.connectionTypes = response.data.data;
    });
    // pop list
    pop_typeAPI.getList().then((response) => {
      this.popList = response.data.data;
    });
    // get District
    // this.getDistrictList();
    areaRelatedAPI.districtList().then(
      (response) => {
        this.districtList = response.data.data.map((e) => {
          return {
            ...e,
            code: e.id,
            label: e.name,
          };
        });
      },
      (err) => {
        if (err.response.data.success === false) {
          this.districtList = [];
        }
      }
    );

    // get data
    var url = window.location.href;
    var id = Number(url.substring(url.lastIndexOf("/") + 1));
    console.log(id);
    if (id) {
      this.customer_id = id;
      customerAPI.getDetails(id).then((response) => {
        this.data = response.data.data;
        try {
          if(this.data.initial_date != undefined) {
          this.data.initial_date = moment(this.data.initial_date).format("yyyy-MM-DD")
          this.company_name = this.customer_name ?? ""
        }

      
        } catch (error) {
          console.log("er");
        }
      });
    }
  },

};
</script>
<style scoped>
fieldset.d-block {
  background: white;
  border-radius: 15px;
  border: 1px solid white;
  padding: 25px;
}
</style>
